export const API_BASE = process.env.REACT_APP_API_BASE || "https://system-pan-core-2026-production.up.railway.app";